/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

export const deleteProductVendor = createAsyncThunk(
  'productVendors/delete',
  async ({ productVendorId, title }, {
    extra: {
      sdk, localization, Logger, showDialogAsync,
    },
  }) => {
    const {
      TITLE, TEXT, OK, CANCEL,
    } = localization.DIALOGS.PRODUCT_VENDOR_DELETE;

    try {
      const { promise } = showDialogAsync({
        title: TITLE(title),
        text: TEXT(),
        textBtnCancel: CANCEL,
        textBtnOk: OK,
      });
      await promise;
    } catch (error) {
      /** user pressed "Cancel" */
      return { cancelled: true };
    }

    try {
      await sdk.productVendors.delete(productVendorId);
      return { productVendorId };
    } catch (error) {
      Logger.error(new Error('Can not delete product vendor'), { error }, [
        'DeleteProductVendorFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(deleteProductVendor.pending, (state, { meta }) => {
      const { productVendorId } = meta.arg;
      if (!state.processingIds.includes(productVendorId)) {
        state.processingIds.push(productVendorId);
      }
    })
    .addCase(deleteProductVendor.fulfilled, (state, { payload, meta }) => {
      state.processingIds = state.processingIds.filter(
        (processingId) => processingId !== meta.arg.productVendorId,
      );
      if (payload.cancelled) return;
      state.items = state.items.filter(({ _id }) => _id !== payload.productVendorId);
      if (!state.searchQuery && state.items.length === 0) {
        state.hasRegistryItems = false;
      }
    })
    .addCase(deleteProductVendor.rejected, (state, { error, meta }) => {
      state.processingIds = state.processingIds.filter(
        (processingId) => processingId !== meta.arg.productVendorId,
      );
      state.error = error;
    });
};
